// mockFloorPlanData.js
//
// Just the status vocabulary for the floor plan tiles/legend/tags — no
// fabricated tables or orders here. The floor plan itself is now built from
// GetresTableList + GetrestableOrderNum (see CaptainDashboard.js), the same
// two APIs TableSelection.js already uses. QR / Booking / Reserved aren't
// derivable from those APIs yet (no source-channel flag, no table-linked
// bookings, no distinct "blocked" table status) — see API_MAPPING.md for
// what's missing before those three can be real instead of aspirational.

export const STATUS = {
    AVAILABLE: 'available',
    PROGRESS: 'progress',
    QR: 'qr',
    BOOKING: 'booking',
    RESERVED: 'reserved',
};

export const STATUS_LABEL = {
    [STATUS.AVAILABLE]: 'Available',
    [STATUS.PROGRESS]: 'In Progress',
    [STATUS.QR]: 'QR Order',
    [STATUS.BOOKING]: 'Booking',
    [STATUS.RESERVED]: 'Reserved / Blocked',
};
